module.exports = __webpack_public_path__ + "static/step-1@2x-86e89b7cb308d75ab71decdb662eaea8.webp";